import { render, staticRenderFns } from "./FotoParlamentarComPalavra.vue?vue&type=template&id=0d5924d5&scoped=true&"
import script from "./FotoParlamentarComPalavra.vue?vue&type=script&lang=js&"
export * from "./FotoParlamentarComPalavra.vue?vue&type=script&lang=js&"
import style0 from "./FotoParlamentarComPalavra.vue?vue&type=style&index=0&id=0d5924d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5924d5",
  null
  
)

export default component.exports